import { useEffect } from "react";

export function Seo({ title, description }) {
  useEffect(() => {
    if (title) document.title = `${title} | Obsidian Art & Tattoo Studio`;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", description);
    }
    return () => { document.title = "Obsidian Art & Tattoo Studio | Springfield VA | Where Precision Meets Prestige"; };
  }, [title, description]);
  return null;
}
